import { useState, useEffect, Dispatch } from 'react';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { Modal, Button, Space, Col, Input, Row, Form, Select, Checkbox } from 'antd';
import {
  PlusCircleOutlined,
  ExclamationCircleOutlined,
  SaveOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import Swal from 'sweetalert2';
import TableSort from '../../../../components/TableSort';
import { useWindowSize } from '../../../../hook/useWindowSize';
import ModalAdicionarNota from '../AdicionarNota';
import SelectParceiro from '../../../../components/SelectParceiro';
import SelectTipoSolicitacao from '../../../../components/SelectTipoSolicitacao';
import SelectEmbarcador from '../../../../components/SelectEmbarcador';
import CentroDistribuicao from './services/centroDistribuicao';
import SelectCidade from './SelectCidade';
import mask, { maskCurrency, maskUnd } from '../../../../utils/mask';
import { useDispatch, useSelector } from 'react-redux';
import { sendMenssageRequest } from '../../../../store/ducks/sendMenssages/actions';
import { loadRequest } from '../../../../store/ducks/atendimentos/actions';
import api from '../../../../service/api';
import { SKW_PREFIX } from '../../../../utils/constants';
import { Anexos, Notas, CriarOcorrencia } from './types';
import Upload from './Upload';
import TextFilter from '../../../../components/TextFilter';
import TextTable from '../../../../components/TextTable';
import moment from 'moment';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { ROLE } from 'utils/roles';
import { TipoSolicitacao } from 'components/SelectTipoSolicitacao/service/tipoSolicitacao';

interface DataType {
  title: string;
  dataIndex: string;
  key: string;
  align: string;
  width?: string;
  render?: (text: any) => JSX.Element;
}

const ModalNovoAtendimento = () => {
  const link = window.location.href;
  const { width }: any = useWindowSize();
  const { TextArea } = Input;
  const { Option } = Select;
  const [form] = Form.useForm();
  const dispatch = useDispatch<Dispatch<Action>>();

  const [visibleModalNovoAtendimento, setVisibleModalNovoAtendimento] = useState(false);
  const [codcidDestino, setCodcidDestino] = useState<number | undefined>();
  const [parceiro, setParceiro] = useState<string>();
  const [tipoSolicitacao, setTipoSolicitacao] = useState<TipoSolicitacao | null>(null);
  const [atualizarListaNotas, setAtualizarListaNotas] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [atendimentoInterno, setAtendimentoInterno] = useState<boolean>(false);
  const [atendenteProprio, setAtendenteProprio] = useState<boolean>(false);

  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const sorter = useSelector((state: ApplicationState) => state.Atendimentos.sorter);
  const state = useSelector((state: ApplicationState) => state);
  const pagination = useSelector((state: ApplicationState) => state.Atendimentos.pagination);
  const filter = useSelector((state: ApplicationState) => state.Atendimentos.filter);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);


  let notas: Notas[] = JSON.parse(
    localStorage.getItem(window.location.pathname + `ListaNotas`) || '[]'
  );

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    notas = JSON.parse(localStorage.getItem(window.location.pathname + `ListaNotas`) || '[]');
    setAtualizarListaNotas(false);
  }, [atualizarListaNotas]);

  const columns: DataType[] = [
    {
      title: 'N° único',
      dataIndex: 'nunota',
      key: 'nunota',
      align: 'center',
      render: (text: any) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      title: 'N° nota',
      dataIndex: 'numNota',
      key: 'numNota',
      align: 'center',
      render: (text: any) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },

    {
      title: 'Emissão',
      dataIndex: 'dtEmissao',
      key: 'dtEmissao',
      align: 'center',
      render: (text: any) => {
        return text ? (
          <TextTable>{moment(text).format('LL')}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: 'Remetente',
      dataIndex: 'remetente',
      key: 'remetente',
      align: 'center',
      render: (text: any) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Origem/UF',
      dataIndex: 'origem',
      key: 'origem',
      align: 'center',
      render: (text: any) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Destinatário',
      dataIndex: 'destinatario',
      key: 'destinatario',
      align: 'center',
      render: (text: any) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Destino/UF',
      dataIndex: 'destino',
      key: 'destino',
      align: 'center',
      render: (text: any) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Peso',
      dataIndex: 'peso',
      key: 'peso',
      align: 'center',
      render(text: any) {
        return text ? (
          <TextTable>{maskUnd(text)} KG</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Valor',
      dataIndex: 'valor',
      key: 'valor',
      align: 'center',
      render(text: any) {
        return text ? (
          <TextTable>{maskCurrency(text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Inserção manual',
      dataIndex: 'nunota',
      key: 'manual',
      align: 'center',
      render(text: any) {
        return !text ? <TextTable>Sim</TextTable> : <TextTable>Não</TextTable>;
      },
    },
  ];

  const onFinish = (values: CriarOcorrencia) => {

    try {
      const jsonTipoSolic = JSON.parse(values?.codTipSol);
      const codTipSol = jsonTipoSolic.codigo;
      setConfirmLoading(true);
      dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number, pagination, sorter));

      api
        .post(`call?serviceName=${SKW_PREFIX}setOcorrencia&token=${state.auth.token}`, {
          ocorrencia: {
            interno: atendimentoInterno,
            proprio: atendenteProprio,
            assunto: values?.assunto,
            codTipSol: codTipSol,
            codParc: values?.codParc,
            urgencia: values?.urgencia,
            codCentro: values?.codCentro,
            codEmbarcador: values?.codEmbarcador,
            codcidDestino: codcidDestino,
            link: link,
            notas: notas,
          },
        })

        .then((res) => {
          form.resetFields();

          const protocolo: number = res.data.ocorrencia.protocolo;
          const anexos: Anexos = JSON.parse(
            localStorage.getItem(window.location.pathname + `ListaAnexos`) || '[]'
          );
          dispatch(sendMenssageRequest(protocolo, values?.ocorrencia, anexos));
          localStorage.removeItem(window.location.pathname + `ListaAnexos`);
          Swal.fire({
            title: 'Ocorrencia registrada com sucesso!',
            html: '',
            showConfirmButton: false,
            timer: 1500,
            icon: 'success',
          });
        })

        .finally(() => {
          setConfirmLoading(false);
          setVisibleModalNovoAtendimento(false);
        });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel criar o agendamento, por favor tente novamente!',
        html: '',
        showConfirmButton: true,
        timer: 2500,
        icon: 'warning',
      });
      setConfirmLoading(false);
    }
  };

  const oncancel = () => {
    form.resetFields();
    setVisibleModalNovoAtendimento(false);
  };

  return (
    <>
      <Button
        data-cy="btnCreateAttend"
        type="primary"
        icon={<PlusCircleOutlined />}
        onClick={() => setVisibleModalNovoAtendimento(true)}
      >
        Nova ocorrência
      </Button>

      <Modal
        title="Cadastro de Ocorrência"
        centered
        visible={visibleModalNovoAtendimento}
        onCancel={() => oncancel()}
        width={1400}
        footer={[]}
      >
        <Form layout="vertical" onFinish={onFinish} form={form}>
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <SelectParceiro
                label={<TextFilter>Cliente final</TextFilter>}
                setParceiro={setParceiro}
                name="codParc"
              />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item name="codCentro">
                <CentroDistribuicao
                  required={true}
                  label={<TextFilter>CD responsável pela atribuição</TextFilter>}
                  name="codCentro"
                />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectCidade name="cidade" setProps={setCodcidDestino} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectTipoSolicitacao
                required={true}
                setTipoSolicitacao={setTipoSolicitacao}
                name="codTipSol"
              />
            </Col>
          </Row>

          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item name="codEmbarcador">
                <SelectEmbarcador name="codEmbarcador" />
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item
                name="urgencia"
                label={<TextFilter>Classificação de urgência</TextFilter>}
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <Select data-cy="classificaUrgencia">
                  <Option value={'URGENTE'}>Urgente</Option>
                  <Option value={'ALTA'}>Alta</Option>
                  <Option value={'MEDIA'}>Média</Option>
                  <Option value={'BAIXA'}>Baixa</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col md={12} sm={24} xs={24}>
              <Form.Item
                name="assunto"
                label={<TextFilter>Assunto</TextFilter>}
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <Input type="text" style={{ width: '100%' }} maxLength={100} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col md={12} sm={12} xs={12}>
              <Form.Item
                name="ocorrencia"
                label={<TextFilter>Descrição do atendimento</TextFilter>}
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <TextArea rows={6} />
              </Form.Item>
            </Col>
            <Col md={12} sm={12} xs={12}>
              <Form.Item name="upload" label={<TextFilter>Anexos</TextFilter>}>
                <Upload />
              </Form.Item>
            </Col>
          </Row>
          {tipoSolicitacao?.exigeNota && (
            <Form.Item
              name="notas"
              rules={[
                notas.length <= 0
                  ? {
                    required: tipoSolicitacao.exigeNota,
                    message: (
                      <span
                        style={{
                          color: '#c00101',
                          backgroundColor: '#fbe1e1',
                          padding: '5px',
                          borderRadius: '4px',
                        }}
                      >
                        <ExclamationCircleOutlined
                          style={{ color: '#c00101', marginRight: '5px' }}
                        />
                        Por favor insira a nota referente ao tipo de solicitação
                      </span>
                    ),
                  }
                  : { required: false },
              ]}
            >
              <ModalAdicionarNota
                parceiro={parceiro}
                setAtualizarListaNotas={setAtualizarListaNotas}
              />
            </Form.Item>
          )}

          {tipoSolicitacao?.exigeNota &&
            width > 768 && (
              <TableSort
                style={{ fontSize: 10, display: 'inline' }}
                columns={columns}
                scroll={{ x: 2000 }}
                dataSource={notas && notas}
              />
            )}

          {tipoSolicitacao?.exigeNota &&
            width < 768 && (
              <TableSort
                style={{ fontSize: 10, display: 'inline' }}
                columns={columns}
                scroll={{ x: 1100 }}
                dataSource={notas && notas}
              />
            )}

          <Form.Item style={{ textAlign: 'right' }}>
            <Space>
              <>
                {(perfil === ROLE.ADMINISTRADOR || perfil === ROLE.ANALISTACD) && (
                  <Checkbox
                    onChange={(e: CheckboxChangeEvent) => setAtendimentoInterno(e.target?.checked)}
                  >
                    Atendimento Interno
                  </Checkbox>
                )}

                {(perfil === ROLE.ADMINISTRADOR || perfil === ROLE.ANALISTACD) && (
                  <Checkbox
                    onChange={(e: CheckboxChangeEvent) => setAtendenteProprio(e.target.checked)}
                  >
                    Atendente Próprio
                  </Checkbox>
                )}
              </>

              <Button onClick={oncancel} icon={<CloseOutlined />}>
                Cancelar
              </Button>
              <Button
                data-cy="cadastrarAtendimento"
                type="primary"
                htmlType="submit"
                loading={confirmLoading}
                icon={<SaveOutlined />}
              >
                Cadastrar
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ModalNovoAtendimento;
